import { ArrowButton } from 'components/ArrowButton/ArrowButton';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import messages from './messages';

export default function LegalNavigation() {
  const { language } = useSelector((state: RootState) => state.language);

  const { legalNavigationMessages } = messages[language];

  return (
    <div className="flex flex-col">
      <h1 className="font-semibold text-2.5x1 mb-2">
        {legalNavigationMessages.header}
      </h1>
      <a href="https://www.altify.app/legal/terms-of-service" target="_blank">
        <div className="bg-background flex mb-2 p-4 py-1 rounded-lg text-header-text text-left">
          <div className="flex h-12 items-center w-1/2">
            {legalNavigationMessages.ourTerms}
          </div>
          <div className="flex flex-col h-12 justify-center w-1/2">
            <ArrowButton className="self-end" />
          </div>
        </div>
      </a>
      <a href="https://www.altify.app/legal/regulatory" target="_blank">
        <div className="bg-background flex mb-2 p-4 py-1 rounded-lg text-header-text text-left">
          <div className="flex h-12 items-center w-1/2">
            {legalNavigationMessages.privacyPolicy}
          </div>
          <div className="flex flex-col h-12 justify-center w-1/2">
            <ArrowButton className="self-end" />
          </div>
        </div>
      </a>
      <a href="https://www.altify.app/legal/regulatory" target="_blank">
        <div className="bg-background flex mb-2 p-4 py-1 rounded-lg text-header-text text-left">
          <div className="flex h-12 items-center w-1/2">
            {legalNavigationMessages.disclaimers}
          </div>
          <div className="flex flex-col h-12 justify-center w-1/2">
            <ArrowButton className="self-end" />
          </div>
        </div>
      </a>
      <a href="https://www.altify.app/legal/risk-disclosure">
        <div className="bg-background flex mb-2 p-4 py-1 rounded-lg text-header-text text-left">
          <div className="flex h-12 items-center w-1/2">
            {legalNavigationMessages.riskDisclosure}
          </div>
          <div className="flex flex-col h-12 justify-center w-1/2">
            <ArrowButton className="self-end" />
          </div>
        </div>
      </a>
    </div>
  );
}
